import cx from "classnames";
import { ReactNode } from "react";

import { getIcon } from "config/icons";
import { useChainId } from "lib/chains";

import "./PageTitle.scss";
import Button from "components/Button/Button";

type Props = {
  title: ReactNode;
  subtitle?: ReactNode;
  className?: string;
  isTop?: boolean;
  showNetworkIcon?: boolean;
  afterTitle?: ReactNode;
  chainId?: number;
  qa?: string;
  hasBackButton?: boolean;
  hasMaxWidth?: boolean;
  subContent?: ReactNode;
};

export default function PageTitle({
  title,
  subtitle,
  className,
  isTop = false,
  showNetworkIcon = false,
  afterTitle,
  chainId,
  qa,
  hasBackButton,
  subContent,
  hasMaxWidth = true,
}: Props) {
  const classNames = cx("Page-title-wrapper w-full", className, { gapTop: !isTop });
  const { chainId: fallbackChainId } = useChainId();
  const currentNetworkIcon = getIcon(chainId ?? fallbackChainId, "network");

  return (
    <div className={classNames} data-qa={qa}>
      {hasBackButton && (
        <Button variant="tertiary" className="w-max min-w-[67px]" size="small" to="/trade">
          Back
        </Button>
      )}
      <div className="mt-21 flex w-full flex-col items-start gap-12 sm:flex-row sm:justify-between">
        <div className={cx("flex max-w-[396px] flex-col gap-4", { "max-w-none": !hasMaxWidth })}>
          <div className="Page-title-group">
            <h2 className="Page-title__text">{title}</h2>
            {showNetworkIcon && (
              <img className="Page-title__icon" src={currentNetworkIcon} alt="Current Network Icon" />
            )}
            {afterTitle}
          </div>
          <div className="text-[12px] font-[500] leading-[1.5] tracking-[0] text-gray-lighter">{subtitle}</div>
        </div>
        {subContent && subContent}
      </div>
    </div>
  );
}
